export default __webpack_public_path__ + "static/media/RhymesBedtime_07.a34e3b32.png";